import { combineReducers } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { CalendarAction } from './calendar/actions';
import { CalendarState, reducer as calendar } from './calendar/reducer';
import { IChatAction } from './chat/actions';
import { IChatState, reducer as chat } from './chat/reducer';
import { ModalAction } from './modal/actions';
import { ModalState, reducer as modal } from './modal/reducer';
import { TaskAction } from './task/actions';
import { reducer as task, TaskState } from './task/reducer';
import { IAction as ITeamScanAction } from './teamScans/actions';
import { ITeamScanState, reducer as teamScan } from './teamScans/reducer';

export * from './calendar/actions';
export * from './chat/actions';
export * from './modal/actions';
export type { Modal } from './modal/reducer';
export * from './task/actions';
export * from './teamScans/actions';

export interface State {
    task: TaskState;
    calendar: CalendarState;
    modal: ModalState;
    teamScan: ITeamScanState;
    chat: IChatState;
}

export type Thunk<T> = ThunkAction<Promise<T>, State, void, Action>;

export const reducer = combineReducers({
    calendar,
    modal,
    task,
    teamScan,
    chat,
});

export type Action =
    | TaskAction
    | CalendarAction
    | ModalAction
    | ITeamScanAction
    | IChatAction;

export type Dispatch = ThunkDispatch<State, void, Action>;

export interface DispatchProp {
    dispatch: Dispatch;
}
